import InboomaBaseModel from './InboomaBaseModel';

export default InboomaBaseModel.extend({

    urlRoot : '/vouchers',

    initialize () {
        InboomaBaseModel.prototype.initialize.apply(this);
    },

    _save (key, val, options) {
        //this.beforeSave(key, val, options);
        console.log('save voucher model hook', key, val, options);
        return Backbone.Model.prototype.save.call(this, key, val, options);
    },

    _rbac : {
        "admin" : {
            "change-role" : true,
            "read-staff" : true,
            "read" : true,
            "write" : true,
            "edit" : true,
            "remove" : true,
        },
        "user" : {
            "change-role" : true,
            "read-staff" : true,
            "read" : true,
            "write" : true,
            "edit" : true,
            "remove" : true,
        },
        "manager" : {
            "change-role" : true,
            "read-staff" : true,
            "read" : true,
            "write" : true,
            "edit" : true,
            "remove" : true,
        },
        "booking-manager" : {
            "change-role" : true,
            "read-staff" : true,
            "read" : true,
            "write" : true,
            "edit" : true,
            "remove" : true,
        },
        "manager-location" : {
            "change-role" : true,
            "read-staff" : true,
            "read" : true,
            "write" : true,
            "edit" : true,
            "remove" : true,
        }
    },

    defaults : {
        id: "",
        voucher_code: "",
        voucher_type_id: "",
        client_id: "",
        created: null,
        modified: null,
        deleted: null,
        created_by: null,
        modified_by: null,
        usage_count: null
    }

});